module.exports = __webpack_public_path__ + "img/accessories_icon_2.2dbff605.png";